import {useState} from "react";
import {Menu, MenuButton, MenuItems, MenuItem, Transition} from "@headlessui/react";
import SmartIcon from "../SmartIcon.tsx";

type ActionsProps = {
  className: string;
};

const TeamMemberAction = ({className}: ActionsProps) => {
  const [open, setOpen] = useState<boolean>(false);

  const menu = [
    {
      id: "0",
      title: "Make admin",
      icon: "star",
      onClick: () => console.log("Make admin"),
    },
    {
      id: "1",
      title: "Delete member",
      icon: "trash",
      onClick: () => console.log("Delete member"),
    },
  ];

  return (
    <div className={className}>
      <Menu>
        {({open}) => (
          <div>
            <MenuButton className="group/menu relative w-6 h-8 py-1">
              <SmartIcon
                className={`fill-n-400/50 rotate-90 transition-colors group-hover/menu:fill-n-700 dark:group-hover/menu:fill-n-300 ${
                  open && "!fill-brandPurple-500"
                } cursor-pointer`}
                name="dots"
              />
            </MenuButton>
            <Transition
              enter="transition duration-100 ease-out"
              enterFrom="transform scale-95 opacity-0"
              enterTo="transform scale-100 opacity-100"
              leave="transition duration-75 ease-out"
              leaveFrom="transform scale-100 opacity-100"
              leaveTo="transform scale-95 opacity-0"
            >
              <MenuItems
                className="absolute top-full -right-2 w-[13.75rem] p-3 bg-n-100 rounded-[1.25rem] shadow-[0_0_1rem_0.25rem_rgba(0,0,0,0.04),0_2rem_2rem_-1rem_rgba(0,0,0,0.1)] dark:bg-n-600">
                <div className="space-y-1">
                  {menu.map((item, index) => (
                    <MenuItem key={index}>
                      <button
                        className="group flex items-center w-full h-10 px-3 rounded-lg base2 font-semibold transition-colors text-n-400 hover:bg-n-200 hover:text-n-700 dark:hover:bg-n-500 dark:hover:text-n-100"
                        onClick={item.onClick}
                      >
                        <SmartIcon
                          className={`shrink-0 w-5 h-5 mr-3 !fill-n-400 transition-colors group-hover:fill-n-700 dark:fill-n-200`}
                          name={item.icon}
                        />
                        {item.title}
                      </button>
                    </MenuItem>
                  ))}
                </div>
              </MenuItems>
            </Transition>
          </div>
        )}
      </Menu>
    </div>
  );
};

export default TeamMemberAction;
